import { render, staticRenderFns } from "./Economic.vue?vue&type=template&id=c5a9df90&scoped=true&"
import script from "./Economic.vue?vue&type=script&lang=js&"
export * from "./Economic.vue?vue&type=script&lang=js&"
import style0 from "./Economic.vue?vue&type=style&index=0&id=c5a9df90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a9df90",
  null
  
)

export default component.exports